/* ============================================================
   Auto-open the cart drawer after add-to-cart.
   The collection-card quick-add and the product page both POST
   to /cart/add via fetch. The theme updates the cart count and
   re-renders the drawer contents, but doesn't actually slide
   the drawer open — customers had no visual confirmation that
   their click worked. This script listens for successful adds
   and calls drawer.open().
   Built 2026-06-12 by Claude via Cowork for Lack Depot.
   ============================================================ */
(function () {
  'use strict';

  if (!window.fetch) return;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = '';
    try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch(e){}
    var isAdd = /\/cart\/add(\.js)?(\?|$)/.test(url);

    var promise = origFetch.apply(this, arguments);
    if (!isAdd) return promise;

    return promise.then(function (response) {
      // Only open if the add actually succeeded (Shopify returns 200 + JSON on success, 422 on error)
      if (response && response.ok) {
        // Small delay so the drawer's renderContents() finishes before we open
        setTimeout(function () {
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function' && !drawer.classList.contains('active')) {
            drawer.open();
          }
        }, 250);
      }
      return response;
    });
  };
})();
